import React from 'react';
import axios from 'axios';
import HOC from './HOC';
import loginimage from './img/erwatodaye.jpg';
import apiUrl from './base_url';

import {
  FaEnvelope,
  FaLock,
  FaPhone,
  FaEye,
  FaEyeSlash,
  FaArrowRight,
  FaUserPlus,
  FaSignInAlt
} from 'react-icons/fa';

import './cssfile/authform.css';

class AuthForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSignIn: true,
      email: '',
      password: '',
      phone: '',
      error: '',
      isLoading: false,
      showPassword: false
    };
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      error: ''
    });
  };

  togglePassword = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword
    }));
  };

  handleSignInSubmit = (event) => {
    event.preventDefault();

    const { email, password } = this.state;

    if (!email || !password) {
      this.setState({
        error: 'Please enter your email and password.'
      });
      return;
    }

    this.setState({
      isLoading: true,
      error: ''
    });

    const data = {
      email,
      password
    };

    axios
      .post(apiUrl + 'serverside/login.php', data)
      .then((response) => {
        console.log(response);

        /*
         * Preserve existing API behaviour.
         */
        if (response.data === 'success') {
          localStorage.setItem('email', email);
          localStorage.setItem('password', password);

          /*
           * Preserve existing regid handling.
           */
          if (response.data.regid) {
            localStorage.setItem('regid', response.data.regid);
          }

          this.props.history.push('/dashboard', {
            email,
            password
          });
        } else {
          this.setState({
            error:
              response.data?.error ||
              'Email ID or password does not match.',
            isLoading: false
          });
        }
      })
      .catch((error) => {
        console.error(error);

        this.setState({
          error: 'Unable to connect to the server. Please try again.',
          isLoading: false
        });
      });
  };

  handleSignUpSubmit = (event) => {
    event.preventDefault();

    const {
      email,
      password,
      phone
    } = this.state;

    if (!email || !password || !phone) {
      this.setState({
        error: 'Please complete all required fields.'
      });
      return;
    }

    this.setState({
      isLoading: true,
      error: ''
    });

    const data = {
      email,
      password,
      phone
    };

    axios
      .post(apiUrl + 'serverside/user.php', data)
      .then((response) => {
        console.log(response);

        alert(response.data);

        window.location.href = '/dashboard';
      })
      .catch((error) => {
        console.error(error);

        this.setState({
          error: 'Registration failed. Please try again.',
          isLoading: false
        });
      });
  };

  toggleSignIn = (event) => {
    if (event) {
      event.preventDefault();
    }

    this.setState({
      isSignIn: true,
      email: '',
      password: '',
      phone: '',
      error: '',
      showPassword: false
    });
  };

  toggleSignUp = (event) => {
    if (event) {
      event.preventDefault();
    }

    this.setState({
      isSignIn: false,
      email: '',
      password: '',
      phone: '',
      error: '',
      showPassword: false
    });
  };

  render() {
    const {
      isSignIn,
      email,
      password,
      phone,
      error,
      isLoading,
      showPassword
    } = this.state;

    return (
      <div className="et-auth-page">

        <div className="et-auth-container">

          {/* =====================================
              LEFT IMAGE / BRAND PANEL
          ====================================== */}

          <div className="et-auth-visual">

            <img
              src={loginimage}
              alt="ErwaToday"
              className="et-auth-image"
            />

            <div className="et-auth-visual-overlay"></div>

            <div className="et-auth-visual-content">

              <div className="et-auth-logo">
                ET
              </div>

              <span className="et-auth-brand">
                ErwaToday
              </span>

              <h1>
                Prepare smarter.
                <br />
                <span>Perform better.</span>
              </h1>

              <p>
                Your preparation platform for online mock tests,
                practice questions and competitive examinations.
              </p>

              <div className="et-auth-benefits">

                <div>
                  <span className="et-benefit-number">
                    01
                  </span>
                  <span>
                    Online Mock Tests
                  </span>
                </div>

                <div>
                  <span className="et-benefit-number">
                    02
                  </span>
                  <span>
                    Practice Questions
                  </span>
                </div>

                <div>
                  <span className="et-benefit-number">
                    03
                  </span>
                  <span>
                    Track Your Preparation
                  </span>
                </div>

              </div>

            </div>
          </div>


          {/* =====================================
              RIGHT FORM PANEL
          ====================================== */}

          <div className="et-auth-form-panel">

            <div className="et-auth-form-wrapper">

              {/* Mobile brand */}
              <div className="et-auth-mobile-brand">
                <div className="et-auth-mobile-logo">
                  ET
                </div>

                <span>
                  ErwaToday
                </span>
              </div>


              {/* Header */}

              <div className="et-auth-heading">

                <span className="et-auth-eyebrow">
                  {isSignIn
                    ? 'WELCOME BACK'
                    : 'GET STARTED'}
                </span>

                <h2>
                  {isSignIn
                    ? 'Sign in to your account'
                    : 'Create your account'}
                </h2>

                <p>
                  {isSignIn
                    ? 'Continue your preparation from where you left off.'
                    : 'Create your candidate account and start preparing.'}
                </p>

              </div>


              {/* Error */}

              {error && (
                <div className="et-auth-error">
                  {error}
                </div>
              )}


              {/* Form */}

              <form
                onSubmit={
                  isSignIn
                    ? this.handleSignInSubmit
                    : this.handleSignUpSubmit
                }
                className="et-auth-form"
              >

                {/* Email */}

                <div className="et-form-group">

                  <label htmlFor="email">
                    Email Address
                  </label>

                  <div className="et-input-wrapper">

                    <FaEnvelope className="et-input-icon" />

                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter your email address"
                      value={email}
                      onChange={this.handleChange}
                      autoComplete="email"
                      required
                    />

                  </div>

                </div>


                {/* Phone */}

                {!isSignIn && (
                  <div className="et-form-group">

                    <label htmlFor="phone">
                      Phone Number
                    </label>

                    <div className="et-input-wrapper">

                      <FaPhone className="et-input-icon" />

                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        placeholder="Enter your phone number"
                        value={phone}
                        onChange={this.handleChange}
                        autoComplete="tel"
                        required
                      />

                    </div>

                  </div>
                )}


                {/* Password */}

                <div className="et-form-group">

                  <div className="et-password-label">

                    <label htmlFor="password">
                      Password
                    </label>

                    {isSignIn && (
                      <span className="et-secure-text">
                        Secure login
                      </span>
                    )}

                  </div>

                  <div className="et-input-wrapper">

                    <FaLock className="et-input-icon" />

                    <input
                      type={
                        showPassword
                          ? 'text'
                          : 'password'
                      }
                      id="password"
                      name="password"
                      placeholder="Enter your password"
                      value={password}
                      onChange={this.handleChange}
                      autoComplete={
                        isSignIn
                          ? 'current-password'
                          : 'new-password'
                      }
                      required
                    />

                    <button
                      type="button"
                      className="et-password-toggle"
                      onClick={this.togglePassword}
                      aria-label={
                        showPassword
                          ? 'Hide password'
                          : 'Show password'
                      }
                    >
                      {showPassword ? (
                        <FaEyeSlash />
                      ) : (
                        <FaEye />
                      )}
                    </button>

                  </div>

                </div>


                {/* Submit */}

                <button
                  type="submit"
                  className="et-auth-submit"
                  disabled={isLoading}
                >

                  {isLoading ? (
                    <span className="et-auth-loading">
                      <span></span>
                      Processing...
                    </span>
                  ) : (
                    <>
                      <span>
                        {isSignIn
                          ? 'Sign In'
                          : 'Create Account'}
                      </span>

                      {isSignIn ? (
                        <FaSignInAlt />
                      ) : (
                        <FaUserPlus />
                      )}
                    </>
                  )}

                </button>

              </form>


              {/* Switch */}

              <div className="et-auth-switch">

                <span>
                  {isSignIn
                    ? "Don't have an account?"
                    : 'Already have an account?'}
                </span>

                <button
                  type="button"
                  onClick={
                    isSignIn
                      ? this.toggleSignUp
                      : this.toggleSignIn
                  }
                >
                  {isSignIn
                    ? 'Create account'
                    : 'Sign in'}
                  <FaArrowRight />
                </button>

              </div>


              {/* Footer */}

              <div className="et-auth-footer">
                <span>
                  © {new Date().getFullYear()} ErwaToday
                </span>

                <span>
                  Secure Candidate Portal
                </span>
              </div>

            </div>

          </div>

        </div>

      </div>
    );
  }
}

export default HOC(AuthForm);